import Loadable from '@townsquare/loadable';
import {
	readingModeRoute,
	goalsAppReadingModeRoute,
	projectsAppReadingModeRoute,
} from '@townsquare/routes/reading-mode-view';

import { readingModeResource } from './resources/readingMode';

// Reading Mode View
const ReadingModeViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "reading-mode-view" */ './ui/index'),
	loading: () => null,
});

readingModeRoute.component = ReadingModeViewLoadable;
readingModeRoute.resources = [readingModeResource];
export const readingModeRouterRoute = readingModeRoute;

goalsAppReadingModeRoute.component = ReadingModeViewLoadable;
goalsAppReadingModeRoute.resources = [readingModeResource];
export const goalsAppReadingModeRouterRoute = goalsAppReadingModeRoute;

projectsAppReadingModeRoute.component = ReadingModeViewLoadable;
projectsAppReadingModeRoute.resources = [readingModeResource];
export const projectsAppReadingModeRouterRoute = projectsAppReadingModeRoute;
